(ns practitest.frontend.components2.dashboard.charts.line.helper
  (:require ["d3" :as d3]
           [practitest.frontend.components2.dashboard.helpers :as helpers]))

(defn- get-max-y-data-for-line [line]
  (let [data (:line-data line)]
    (if (seq data)
      (apply max (map :y-data data))
      0)))

(defn get-data-with-max-y-data [lines]
  (when (seq lines)
    (let [line-with-max-y-data (apply max-key get-max-y-data-for-line lines)]
      (:line-data line-with-max-y-data))))

(defn get-parse-data [parse-date-format date]
  (if parse-date-format
      ((.utcParse d3 parse-date-format) date)
      date))

(def ease-fns
  {:d3/ease-cubic-out    (.-easeCubicOut d3)
   :d3/ease-cubic-in     (.-easeCubicIn d3)
   :d3/ease-cubic-in-out (.-easeCubicInOut d3)})

(defn resolve-ease [k]
  (get ease-fns k (.-easeCubicOut d3)))

(defn hidden-lines-set
  [chart lines-configs]
  (->> lines-configs
       (keep (fn [{:keys [line-name]}]
               (when-not (helpers/legend-item-active? chart line-name)
                 line-name)))
       set))
